import React from 'react'
import { Container} from 'reactstrap';

 class Home extends React.Component{
 
  render() {
    return (
      <Container fluid>        
        <br/>
        <p>Moduł umożliwia dostęp do funkcjonalności agencyjnej systemu <a href="https://moj-bus.pl" target="_blank" rel="noopener noreferrer">Moj-Bus.pl</a></p>
        <p>W celu uzyskania uprawnień do obsługi tego modułu należy:</p>
        <ul>
          <li>Założyć konto (zwykłego użytkownika) w systemie Moj-Bus.pl. Konto można założyć <a href="https://moj-bus.pl/user/register" target="_blank" rel="noopener noreferrer">tutaj</a>.</li>
          <li>U administratora danego agenta uzyskać uprawnienia dostępu podając adres e-mail użyty przy rejestracji.</li>
        </ul>
        <br/>
        <p>Kontem można zarzadzać poprzez mechanizmy dostepne na stronie <a href="https://moj-bus.pl" target="_blank" rel="noopener noreferrer">Moj-Bus.pl</a></p>
        <p>W szczególności w przypadku utraty hasła należy skorzystać ze strony <a href="https://moj-bus.pl/user/newpassword" target="_blank" rel="noopener noreferrer">Moj-Bus.pl :: zmiana utraconego hasła</a></p>
      </Container>)
  }
}
                   
export default Home;


// WEBPACK FOOTER //
// ./src/Home.js